import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { questionnaireRecordList } from './request';
import { customerResource } from '@/views/system/customerManage/request';
export default {
  data() {
    return {
      form: {
        customerId: undefined
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'serialNo',
        key: '1',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '问卷名称'
        },
        dataIndex: 'questionnaireName',
        key: 'questionnaireName',
        align: 'center'
      }, {
        slots: {
          title: '归属客户'
        },
        dataIndex: 'customerName',
        key: 'customerName',
        align: 'center'
      }, {
        slots: {
          title: '申请人'
        },
        dataIndex: 'userName',
        key: 'userName',
        align: 'center'
      }, {
        slots: {
          title: '审核状态'
        },
        dataIndex: 'status',
        key: '10',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        slots: {
          title: '申请时间'
        },
        dataIndex: 'createAt',
        key: 'createAt',
        align: 'center'
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: 'updateAt',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        width: 220,
        key: '8',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      data: [],
      policySelectList: []
    };
  },
  async created() {
    this.policySelectList = await customerResource({});
    let arr = this.policySelectList.filter(item => item.id == Number(sessionStorage.getItem('customerId')));
    this.form.customerId = arr.length != 0 ? Number(sessionStorage.getItem('customerId')) : this.policySelectList[0].id;
    this.getDataFun();
  },
  methods: {
    async getDataFun() {
      const {
        items,
        totalNum
      } = await questionnaireRecordList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.data = items;
      this.pagination.total = totalNum;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.data = [];
      this.getDataFun();
    },
    handleEdit(val) {},
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    }
  }
};